<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/simpeg-pegawai-list">Daftar Pegawai</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Pemegang Kendaraan Dinas
        </li>
      </ol>
    </nav>
    <div class="content-block">
      <h5>Daftar Pemegang Kendaraan Dinas</h5>
    </div>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          ref="gridRef"
          id="gridContainer"
          :data-source="dataSource"
          :allow-column-reordering="true"
          :show-borders="true"
          @editor-preparing="oneditorpreparing"
          :focused-row-index="0"
          :show-column-lines="false"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @option-changed="onPageChanged"
          @exporting="onExporting"
          :filter-sync-enabled="true"
          :word-wrap-enabled="true"
          :height="gridHeight"
        >
          <DxExport :enabled="true" />

          <DxToolbar>
            <DxItem location="after" template="refresh-template" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('gridRef')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>
          <DxFilterRow :visible="showFilterRow" :apply-filter="currentFilter" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <DxPaging :enabled="true" :page-size="150" />
          <DxEditing
            :allow-updating="false"
            :allow-deleting="false"
            :allow-adding="false"
            mode="row"
          />
          <!-- <DxSelection mode="multiple" /> -->
          <DxColumnFixing :enabled="true" />
          <DxColumn
            caption="#"
            data-field="created_at"
            cell-template="numberingTemplate"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
          />

          <template #numberingTemplate="{ data }">
            {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
          </template>
          <DxColumn
            data-field="simpegPegawai.nik"
            caption="NIK"
            data-type="string"
          >
          </DxColumn>
          <DxColumn
            data-field="simpegPegawai.nama"
            caption="Pegawai"
            data-type="string"
          >
          </DxColumn>

          <DxColumn data-field="tipe" caption="Tipe" data-type="string">
          </DxColumn>
          <DxColumn data-field="plat_no" caption="No. Plat" data-type="string">
          </DxColumn>

          <DxColumn
            data-field="tgl_mulai"
            caption="Tgl Mulai"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
          />
          <DxColumn
            data-field="tgl_akhir"
            caption="Tgl Akhir"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
          />

          <DxColumn
            data-field="status"
            caption="Status"
            :dataType="'boolean'"
            cell-template="templateStatus"
          >
            <DxLookup
              display-expr="nama"
              value-expr="val"
              :data-source="statusSource"
            />
          </DxColumn>
          <template #templateStatus="{ data }">
            <StatusTemplate :value="data.value" />
          </template>

          <DxColumn
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-editing="false"
            :allow-adding="false"
            cell-template="fileTemplate"
            caption="Dokumen"
            data-field="file_path"
            data-type="string"
          />

          <template #fileTemplate="{ data }">
            <div class="small-button-container">
              <DxButton
                :visible="setPrintAdaFile(data.text)"
                @click="handleClickDocument(data)"
                icon="download"
              />
            </div>
          </template>
          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="pegawai_id"
            data-type="number"
            caption=" "
            :allow-exporting="false"
            :allow-filtering="false"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="options"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_URL } from "@/global-constants";
import notify from "devextreme/ui/notify";
import _ from "lodash";
import { ODATA_BASE_URL } from "@/global-constants";
import DxButton from "devextreme-vue/button";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import router from "@/router";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxExport,
  DxToolbar,
  DxItem,
} from "devextreme-vue/data-grid";
import StatusTemplate from "./StatusTemplate.vue";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
function getUrlFilter() {
  return router.currentRoute.value.query.filter;
}
const options = ["Detail Pegawai", "Absensi", "Riwayat Gaji"];

const dataSource = new DataSource({
  store: new ODataStore({
    // ODataStore is configured here
    url: `${ODATA_BASE_URL}/RiwayatTransports`,
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };

      if (typeof e.params.$filter == "undefined") {
        // e.params.$filter = "month(tgl) eq '5' and year(tgl) eq '2023'";
        e.params.$filter = getUrlFilter();
      }
      if (hasFilterNestedTable(e.params.$filter)) {
        e.params.$filter = convertFilterPegawai(e.params.$filter);
      }
      e.params.$orderby = "status desc";
    },
  }),
  expand: ["simpegPegawai"],
});

function hasFilterNestedTable(str) {
  return (
    _.includes(str, "/") ||
    _.includes(str, "[") ||
    _.includes(str, "]") ||
    _.includes(str, "riwayatPekerjaan/") ||
    _.includes(str, "riwayatGolongan/") ||
    _.includes(str, "pegawai/") ||
    _.includes(str, "simpegPegawai/")
  );
}

function convertFilterPegawai(filter) {
  var searchTerm = (filter.match(
    /contains\(tolower\(simpegPegawai\/nama\),'([^']+)'/
  ) || [])[1];
  var replacedString = filter.replace(
    /contains\(tolower\(simpegPegawai\/nama\),'([^']+)'/,
    `simpegPegawai/any(s:(contains(tolower(s/nama),'${searchTerm}'))`
  );

  var searchTermNik = (replacedString.match(
    /contains\(tolower\(simpegPegawai\/nik\),'([^']+)'/
  ) || [])[1];
  var replacedStringNik = replacedString;

  replacedStringNik = replacedString.replace(
    /contains\(tolower\(simpegPegawai\/nik\),'([^']+)'/,
    `simpegPegawai/any(s:(contains(tolower(s/nik),'${searchTermNik}'))`
  );

  return replacedStringNik;
}
export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxLookup,
    DxPager,
    DxDropDownButton,
    DxButton,
    DxExport,
    DxToolbar,
    DxItem,
    StatusTemplate,
  },
  data() {
    return {
      serverUrl: `${BASE_URL}/`,
      statusSource: [
        { val: true, nama: "Aktif" },
        { val: false, nama: "Tidak Aktif" },
      ],
      numberingPageSize: 10,
      numberingPageNumber: 0,
      router: router,
      options: options,
      // pegawaiSource: new ODataStore({
      //   url: "http://127.0.0.1/odata/SimpegPegawais",
      //   key: "id",
      // }),
      filterValue: "",
      dataSource,
      editingOptions: {},
      showFilterRow: true,
      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],
      filterOperations: ["=", "<>", ">", "<", "between"],
      calculateFilterExpression: function (
        filterValue,
        selectedFilterOperation,
        target
      ) {
        let column = this;
        if (selectedFilterOperation === "=" && target == "filterRow") {
          let bulan = filterValue.getMonth() + 1;
          var filterExpression = [
            "month(" +
              column.dataField +
              ") eq " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterRow") {
          //notequal
          let bulan = filterValue.getMonth() + 1;
          var filterExpression2 = [
            "month(" +
              column.dataField +
              ") ne " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") ne " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression2;
        }
        if (selectedFilterOperation === "<" && target == "filterRow") {
          //less than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression3 = [
            "year(tgl) lt " +
              filterValue.getFullYear().toString() +
              " or (year(tgl) eq " +
              filterValue.getFullYear().toString() +
              " and month(tgl) lt " +
              bulan +
              ")",
          ];
          return filterExpression3;
        }
        if (selectedFilterOperation === ">" && target == "filterRow") {
          //greater than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression4 = [
            "year(tgl) gt " +
              filterValue.getFullYear().toString() +
              " or (year(tgl) eq " +
              filterValue.getFullYear().toString() +
              " and month(tgl) gt " +
              bulan +
              ")",
          ];
          return filterExpression4;
        }

        if (selectedFilterOperation === "between" && target == "filterRow") {
          // (year(Date) eq 2022 and month(Date) ge 5) or (year(Date) eq 2023 and month(Date) le 6)
          let bulan1 = filterValue[0].getMonth() + 1;
          let bulan2 = filterValue[1].getMonth() + 1;

          var filterExpression5 = [
            "month(tgl) ge " +
              bulan1 +
              " and year(tgl) ge " +
              filterValue[0].getFullYear() +
              " and " +
              "month(tgl) le " +
              bulan2 +
              " and year(tgl) le " +
              filterValue[1].getFullYear(),
          ];

          return filterExpression5;
        }

        // Invokes the default filtering behavior
        return column.defaultCalculateFilterExpression(arguments);
      },
      oneditorpreparing: function (e) {
        if (e.dataField === "tgl") {
          e.editorOptions.calendarOptions = {
            minZoomLevel: "year",
            maxZoomLevel: "year",
            displayFormat: "MM/yyyy",
            type: "month",
          };
        }
      },
    };
  },
  mounted() {},
  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },
  methods: {
    setPrintAdaFile(e) {
      if (_.isEmpty(e)) return false;
      else return true;
    },

    handleClickDocument(e) {
      this.fileUrl = e.data.file_path;
      this.downloadFile();
    },
    downloadFile() {
      if (this.fileUrl !== null) {
        window.open(this.serverUrl + this.fileUrl, "_blank", "location=yes");
      } else {
        notify("File tidak ada", "error");
      }
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Sheet 1");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Pemegang Kendaraan Dinas.xlsx"
          );
        });
      });
      e.cancel = true;
    },

    refreshDatagrid(gridRef) {
      this.$refs[gridRef].instance.getDataSource().reload();
    },
    onPageChanged(e) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs.gridRef.instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },

    onItemClick(e) {
      let pegawaiId = e.element.id;

      if (e.itemData === "Absensi") {
        const url = this.$router.resolve({
          name: "absen-list-custom",
          query: { filter: ["pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "simpeg-pegawai-detail",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }
    },
  },
};
</script>
